import Text from '@sats-group/ui-lib/react/text';
import clsx from 'clsx';
import React from 'react';
import type { Panel as Props } from './panel.types';

export const Panel: React.FC<React.PropsWithChildren<Props>> = ({
  category,
  children,
  title,
  width,
}) => (
  <div className={clsx('panel', { [`panel--w-${width}`]: width })}>
    <div className="panel__head">
      <div className="panel__category">
        <Text size={Text.sizes.small}>{category}</Text>
      </div>
      <div className="panel__title">
        <Text size={Text.sizes.basic} theme={Text.themes.emphasis}>
          {title}
        </Text>
      </div>
    </div>
    <div className="panel__children">{children}</div>
  </div>
);
